// FE mirror of backend's _conditional_is_unmet (check_in.py).
//
// Given a field with a conditional rule and a map of current responses keyed
// by field uuid, returns true if the field should be rendered.
//
// Reads the primitive from the typed key (text/number/bool/option) derived
// from the parent's field_type — not the first value in the dict — so extra
// keys can't change which primitive is compared.
//
// If the field has no rule, always shown. If the parent has no answer yet,
// the field is hidden — consistent with backend.

const VALUE_KEY_BY_FIELD_TYPE = {
  text: "text",
  scale: "number",
  yes_no: "bool",
  single_select: "option",
};

function shouldRenderField(field, responsesByFieldUuid) {
  if (!field.conditional_on_field_uuid || !field.conditional_operator) {
    return true;
  }

  const parentResponse = responsesByFieldUuid[field.conditional_on_field_uuid];
  if (parentResponse == null || typeof parentResponse !== "object") return false;

  const parentType = field.conditional_on_field_type;
  const expectedKey = VALUE_KEY_BY_FIELD_TYPE[parentType];
  if (!expectedKey) return false;

  const actual = parentResponse[expectedKey];
  if (actual == null) return false;

  const expectedValueObj = field.conditional_value;
  if (!expectedValueObj || typeof expectedValueObj !== "object") return true;
  const expected = expectedValueObj[expectedKey];
  if (expected == null) return true;

  switch (field.conditional_operator) {
    case "equals":
      return actual === expected;
    case "less_than":
      try { return actual < expected; } catch { return false; }
    case "greater_than":
      try { return actual > expected; } catch { return false; }
    default:
      return true;
  }
}

export default shouldRenderField;
